export class EpisodePreEvaluationRequest {
    public idEpisode: number;

    public idSymptomDuration: number;

    public symptomDescription: string;
}